interface ProductBrand {
  id?: number;
  name?: string;
  code?: string;
  companyId?: number;
  productsCount?: number;
}

export const newProductBrand = (): ProductBrand => {
  return {};
};

export default ProductBrand;
